import TestChatDialog from "@/components/ai-training/test-chat-dialog/test-chat-dialog";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { Link, useLocation } from "react-router";

const valueContainedInLastPath = (pathname: string, value: string) => {
    const lastPath = pathname.split("?")[0].split("/").pop();
    return lastPath === value;
};

const LayoutTabHeader = () => {
    const location = useLocation();
    return (
        <div className="mb-4 flex flex-col items-stretch gap-4 md:flex-row">
            <Card className="flex-1 border bg-gray-200 shadow-none">
                <div className="flex w-full  max-w-[calc(100vw-70px)] gap-3 overflow-x-auto p-1  md:overflow-x-hidden">
                    <Link
                        to="look-and-feel"
                        className={cn(
                            valueContainedInLastPath(location.pathname, "look-and-feel") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Look & Feel
                    </Link>
                    <Link
                        to="predefined-questions"
                        className={cn(
                            valueContainedInLastPath(location.pathname, "predefined-questions") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Predefined Questions
                    </Link>
                    {/* <Link
                        to="configuration"
                        className={cn(
                            valueContainedInLastPath(location.pathname, "configuration") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Configuration
                    </Link> */}
                    <Link
                        to="integrations"
                        className={cn(
                            valueContainedInLastPath(location.pathname, "integrations") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Integrations
                    </Link>
                    <Link
                        to="installation"
                        className={cn(
                            valueContainedInLastPath(location.pathname, "installation") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Installation
                    </Link>
                    <Link
                        to="custom-prompt"
                        className={cn(
                            valueContainedInLastPath(location.pathname, "custom-prompt") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Custom Prompt
                    </Link>
                </div>
            </Card>
            <div className="flex items-center justify-center rounded-lg bg-gray-200 p-2">
                <TestChatDialog />
            </div>
        </div>
    );
};

export default LayoutTabHeader;
